import { gsap } from "gsap";
import GspAnimate from "../modules/GspAnimate";
const gspAnimate= new GspAnimate();

class SectionFlow {
    init(){
        this.cardPoint=document.querySelectorAll('.card-flow');
        gspAnimate.StagerAnimation(this.cardPoint)
    } 
}
export default SectionFlow